<template>
  <div>
    <form ref="loginForm" @submit.prevent="login">
      <fieldset>
        <h2 class="ttl__common">ログイン</h2>
        <error-messages
          v-if="errorMessages.length > 0"
          :errorMessages="errorMessages"
        />
        <div class="form_list">
          <label>メールアドレス</label>
          <input
            type="text"
            v-model="model.mailAddress"
            maxlength="100"
            placeholder="メールアドレスを入力してください"
          />
        </div>
        <div class="form_list">
          <label>パスワード</label>
          <input
            type="password"
            v-model="model.password"
            maxlength="64"
            placeholder="パスワードを入力してください"
          />
        </div>

        <div class="btns">
          <div class="btn__common">
            <input type="submit" name="Submit" value="ログイン" class="" />
          </div>
          <div class="btn__common typeBlack">
            <input
              type="button"
              name="Submit"
              value="新規登録はこちら"
              class=""
              v-on:click="goMailRegist"
            />
          </div>
        </div>

        <div class="form_check">
          <input id="keep" type="checkbox" value="" v-model="model.keepFlg" />
          <label for="keep">ログイン状態を保持する</label>
        </div>
        <a
          @click="openOtherWindow('Contact', { fromDiv: '070' })"
          class="cursor"
        >
          メールアドレスをお忘れの方はこちら </a
        ><br />

        <a @click="goPasswordReissue" class="cursor">
          パスワードをお忘れの方はこちら
        </a>
      </fieldset>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import constConfig from "@/common/const";
import Cookies from "js-cookie";
import errorMessages from "@/components/common/ErrorMessages.vue";

export default {
  name: "LoginInput",
  data() {
    return {
      thisViewId: String,
      loading: false,
      transitionId: "VIEW0002",
      errorMessages: [],
      // メールアドレス入力フォーム
      model: {
        mailAddress: undefined,
        password: undefined,
        keepFlg: false,
        token: undefined,
        referer: undefined,
        simulationNo: undefined
      },
      mailCompareMsg: undefined,
      showPassword: false,
      token: undefined,
      nodeEnv: ""
    };
  },
  components: {
    "error-messages": errorMessages
  },
  created: async function() {
    this.thisViewId = constConfig.VIEW_LOGIN.id;
    await this.init();
  },
  mounted: function() {
    this.nodeEnv = process.env.NODE_ENV;
  },
  watch: {
    "$parent.$data.visible": function(val) {
      if (!val) {
        this.errorMessages = [];
      }
    }
  },
  methods: {
    init: async function() {
      this.loading = true;
      const formData = new FormData();
      formData.append("transitionId", this.transitionId);
      await axios
        .post("/api/authentication/login/init", formData)
        .then(res => {
          if (res.data.result == 1) {
            this.$router.push({ name: "Error" });
          } else if (res.data.url != null) {
            this.$router.push({ path: res.data.url });
          }
          this.model.token = res.data.token;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
          this.$router.push({ name: "Error" });
        });
    },
    login: function() {
      axios
        .post("/api/authentication/login/check", this.model)
        .then(res => {
          if (res.data.result == 0) {
            if (res.data.url != null) {
              // 仮パスワードの場合
              this.model.mailAddress = "";
              this.model.password = "";
              this.$emit("login-success", "1");
              let transitInfo = this.getViewInfoFromPath(res.data.url);
              this.$router.push({
                name: transitInfo.name,
                params: { loginKeepFlg: this.model.keepFlg ? "1" : "0" }
              });
              this.commonCloseLoginModal($.magnificPopup);
            } else {
              this.model.mailAddress = "";
              this.model.password = "";
              this.$store.commit("setLoggedIn", true);
              this.$emit("login-success", $.magnificPopup, this.$router);
            }
          } else if (res.data.result == 9) {
            this.$router.push({ name: "Error" });
          } else {
            this.loading = false;
            this.dsipErrorMessages(res.data.errorMessages);
          }
          if (res.data.authKey != "") {
            Cookies.set("livnex_cookie_authKey", res.data.authKey, {
              expires: 30,
              secure: this.nodeEnv != "local",
              sameSite: "lax"
            });
            Cookies.set("livnex_cookie_loginKeepFlg", res.data.loginKeepFlg, {
              expires: 30,
              secure: this.nodeEnv != "local",
              sameSite: "lax"
            });
          }
        })
        .catch(error => {
          console.log(error);
          this.$router.push({ name: "Error" });
          this.loading = false;
        });
    },
    goMailRegist: function() {
      // ログインモーダルを閉じる
      this.$emit("mail-regist", $.magnificPopup, this.$router);
    },
    goPasswordReissue: function() {
      // ログインモーダルを閉じる
      this.$emit("pw-reissue", $.magnificPopup, this.$router);
    },
    dsipErrorMessages: function(messages) {
      this.errorMessages = messages;
      // this.scrollTop();
    }
  }
};
</script>

<style lang="scss">
.cursor {
  cursor: pointer;
}
</style>
